// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.comma-list li[data-v-1d94af67]::after {\n  content: \", \";\n}\n.comma-list li[data-v-1d94af67]:last-child::after {\n    content: \"\";\n}\na[data-v-1d94af67] {\n\tmargin:0;\n}\n\n", ""]);
// Exports
module.exports = exports;
